import React, { useEffect, useState } from "react";
import { Modal, ModalProps } from "../modal/modal";
import {
  modalStreamIn,
  modalStreamOut,
  modalStreamUpdateCurrentProps,
} from "./modal-service";

export function ModalServiceOutput() {
  const [component, setComponent] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const sub = modalStreamIn.subscribe((nextComponent) => {
      setComponent(nextComponent);
      setShow(true);
    });
    const updateSub = modalStreamUpdateCurrentProps.subscribe(
      (nextProps: ModalProps) => {
        setComponent({
          ...component,
          modalProps: {
            ...component.modalProps,
            ...nextProps,
          },
        });
      }
    );
    return () => {
      sub.unsubscribe();
      updateSub.unsubscribe();
    };
  }, [component]);

  const modalResolve = (data: any) => {
    modalStreamOut.next({ id: component.id, data });
    setShow(false);
  };

  const onCloseAnimateComplete = () => {
    setComponent(null);
  };

  const Component = component?.Component || undefined;
  const props = component?.props;
  const modalProps = component?.modalProps;

  return (
    !!Component && (
      <Modal
        show={show}
        {...modalProps}
        onCloseAnimateComplete={onCloseAnimateComplete}
        onClose={() => modalResolve(null)}
      >
        <Component modalResolve={modalResolve} {...props} />
      </Modal>
    )
  );
}
